import { render, staticRenderFns } from "./AccountSettings.vue?vue&type=template&id=5b672876&"
import script from "./AccountSettings.vue?vue&type=script&lang=js&"
export * from "./AccountSettings.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettings.vue?vue&type=style&index=0&id=5b672876&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports